import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { CompanySection, LogoSection } from "@/components/settings/CompanySection";
import { EstimateSection } from "@/components/settings/EstimateSection";
import { GlassSection } from "@/components/settings/GlassSection";
import { DangerZone } from "@/components/settings/DangerZone";
import { RecentlyDeleted } from "@/components/settings/RecentlyDeleted";

export default function Settings() {
  const [settings, setSettings] = useState(null);
  const [catalogKey, setCatalogKey] = useState(0);
  const load = () => api.get("/settings").then((r) => setSettings(r.data)).catch((e) => toast.error(errorMessage(e)));
  useEffect(() => { load(); }, []);
  const setCompany = (company) => setSettings((s) => ({ ...s, company }));

  return (
    <div className="space-y-10" data-testid="settings-page">
      <div className="rise">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-50">Settings</h1>
        <p className="mt-2 text-sm text-slate-400">Estimate defaults, glass spec names and branding. Types, product lines and every rate are in Products & pricing.</p>
        <Link to="/products" data-testid="settings-products-link" className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-300 hover:text-amber-200">Open Products & pricing <ArrowRight className="h-4 w-4" /></Link>
      </div>
      {!settings ? (
        <div className="h-96 animate-pulse rounded-2xl bg-slate-900/50" />
      ) : (
        <div className="rise rise-1 grid gap-8 xl:grid-cols-[1.4fr_1fr]">
          <div className="min-w-0 space-y-8">
            <EstimateSection key={`e${catalogKey}`} company={settings.company} onChange={setCompany} />
            <GlassSection key={`g${catalogKey}`} company={settings.company} onChange={setCompany} />
          </div>
          <div className="min-w-0 space-y-8">
            <LogoSection />
            <CompanySection company={settings.company} />
          </div>
          <div className="min-w-0 xl:col-span-2">
            <RecentlyDeleted />
          </div>
          <div className="min-w-0 xl:col-span-2">
            <DangerZone onDone={(a) => { if (a === "settings") load().then(() => setCatalogKey((k) => k + 1)); }} />
          </div>
        </div>
      )}
    </div>
  );
}
